import { useTranslation } from "react-i18next"

import { AppBreadcrumb } from "@/components/layout/app-breadcrumb"
import { DashboardContainer } from "@/components/layout/dashboard-container"
import { Header } from "@/components/layout/header"
import { SubscriptionDetails } from "@/components/subscriptions/details"
import { FRONTEND_ROUTES } from "@/constants"

export function SubscriptionDetailsPage() {
  const { t } = useTranslation()

  return (
    <DashboardContainer>
      <Header>
        <AppBreadcrumb
          links={[
            {
              href: FRONTEND_ROUTES.DASHBOARD.href,
              label: t("sidebar.dashboard"),
            },
            {
              href: FRONTEND_ROUTES.SUBSCRIPTIONS.href,
              label: t("sidebar.subscriptions"),
            },
            {
              label: t(
                "pages.subscriptions.subscriptionDetails"
              ),
            },
          ]}
        />
      </Header>
      <section className="flex flex-1 flex-col gap-4 overflow-x-hidden p-4 @container">
        <SubscriptionDetails />
      </section>
    </DashboardContainer>
  )
}
